import './accordion.scss';

import React, { useState } from 'react';

import ReactMarkdown from 'react-markdown';

Accordion.defaultProps = {
    className: '',
    name: 'accordion',
    title: '',
    content: '',
};

export default function Accordion(props: { title: string; content: string }) {
    const [open, setOpen] = useState(false);

    return (
        <div className='accordion'>
            <div
                className='header'
                onClick={() => {
                    setOpen(!open);
                }}
            >
                <h2 className='title'>{props.title}</h2>
                <span
                    style={{ transform: open ? 'rotate(180deg)' : 'none' }}
                    className='iconfont iconfont-tiroir-down'
                ></span>
            </div>
            <div
                style={{ display: open ? 'block' : 'none' }}
                className='content'
            >
                <ReactMarkdown>{props.content}</ReactMarkdown>
            </div>
        </div>
    );
}
